import styled from 'styled-components'

import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

import colors from 'components/utils/colors'

const StyledMenu = styled(InnerComponent).attrs({ Component: components.Menu })`
  &.react-select__menu {
    font-size: 14px;
    margin-top: 0;
    border-radius: 0;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.29);
    width: fit-content;
    min-width: 100%;
  }

  .react-select__menu-list {
    padding-top: 0;
    padding-bottom: 0;
  }

  .react-select__group {
    padding: 0;

    .react-select__group-heading {
      text-transform: none;
      font-size: 10px;
      font-weight: 600;
      color: ${colors.secondary60};
      letter-spacing: 0.5px;
      padding: 6px 3px 2px 4px;
    }
  }
`

const Menu = (props) => {
  return (
    <StyledMenu {...props} />
  )
}

export default Menu
